import { Schema } from '../../type';

export const personneMoraleSchemaVersionBtn: Schema = {
    style: { width: 100 },
    ref: 'personneMoraleVersionGroup/personneMoraleList',
    title: 'Versions',
    type: 'subSchema',
    subSchema: {
        display: 'drawer',
        multi: false,
        itemName: 'version',
        config: {
            modelName: 'version',
            itemName: 'une version',
            apiUrl: '/personnesMorales',
            options: ['update', 'newVersion'],
        },
        schemas: [
            { style: { width: 240 }, ref: 'raisonSociale' },
            {
                style: { width: 160 },
                ref: 'adresse/ligne1',
            },
            { style: { width: 140 }, ref: 'telephone' },
            { style: { width: 140 }, ref: 'email', type: 'email' },
            { style: { width: 140 }, ref: 'notes', type: 'note' },
            {
                style: { width: 100 },
                ref: 'status',
                type: 'select',
                valueMap: [
                    { value: 'actif', color: 'green', icon: 'CheckIcon' },
                    { value: 'inactif', color: 'red', icon: 'XMarkIcon' },
                ],
            },
            {
                style: { width: 140 },
                ref: 'version',
                type: 'amount',
                ban: ['update', 'create'],
            },
        ],
    },
};
